import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ContentFeed, ContentFeedSource} from '../../../contentFeeds.types';

interface ContentFeedPageBaseState {
  isLoading: boolean;
  feed: ContentFeed | null;
}

const contentFeedPageBaseInitialState: ContentFeedPageBaseState = {
  isLoading: false,
  feed: null,
};

const contentFeedPageBaseSlice = createSlice({
  name: 'contentFeedPageBase',
  initialState: contentFeedPageBaseInitialState,
  reducers: {
    resetContentFeedPage: () => contentFeedPageBaseInitialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setFeed: (state, action: PayloadAction<ContentFeed>) => {
      state.feed = action.payload;
    },
    setFeedName: (state, action: PayloadAction<string>) => {
      if (state.feed) {
        state.feed.name = action.payload;
      }
    },
    setFeedSource(state, action: PayloadAction<ContentFeedSource>) {
      if (state.feed) {
        state.feed.feedSource = action.payload;
      }
    },
    clearFeed: (state) => {
      state.feed = null;
    },
  },
});

export const {resetContentFeedPage, setIsLoading, setFeed, setFeedName, setFeedSource, clearFeed} =
  contentFeedPageBaseSlice.actions;

export default contentFeedPageBaseSlice.reducer;
